export const WidgetRenderDelays = {
    'vertical_cylinder_tank':0.6
};